<template class="main">
  <v-app id="app">
    <nav-bar :language="language"/>
    <announcement :language="language"/>
    <router-view :language="language"/>
    <v-card v-if="snackbar" width="160px" max-height="140px" class="rounded-xl elevation-15" style="position: fixed; bottom: 20px; right: 20px; z-index: 1111111111;">
      <v-btn small fab color="red accent-2" style="position: absolute; top: -10px; right: -15px; z-index: 1111111111;" @click="snackbar = false">
        <v-icon color="white">
          mdi-close
        </v-icon>
      </v-btn>
      <v-img
        class="rounded-xl"
        width="160px"
        height="130px"
        style="border: 3px solid #FF5252;"
        :src="require('@/assets/portfolio-square.jpg')"
      >
        <a :href="portfolioUrl" target="_blank" style="text-decoration: none;">
          <v-row class="font-weight-bold mt-8" justify="center" align="center">
            <v-col cols=12 style="font-size: 20px; color: #7b7b7d;" align="end" class="my-0 py-0" :class="language=='Ελληνικά' ? 'mr-10' : 'mr-16'">
              {{language=='Ελληνικά'? 'Πορτφόλιο' : 'Portfolio'}}
            </v-col>
            <v-col cols=12 align="center" class="py-0 my-0">
              <v-icon x-large color="#FF5252">
                mdi-cloud-download-outline
              </v-icon>
            </v-col>
          </v-row>
        </a>
      </v-img>
    </v-card>
  </v-app>
</template>

<script>
import Announcement from './components/Announcement.vue';
import NavBar from './components/NavBar.vue';
import restApi from "@/rest-api";

export default {
  components: { NavBar, Announcement},
  name: 'App',
  data() {
    return {
      snackbar: true,
      portfolioUrl: '',
      language: 'Ελληνικά'
    }
  },
  watch: {
    '$store.getters.getLanguage.language': {
      handler() {
        this.language = this.$store.getters.getLanguage.language
        this.getPortfolio()
      }
    }
  },
  created() {
      this.language = this.$store.getters.getLanguage.language
      this.getPortfolio()
  },
  methods: {
    getPortfolio() {
        var search = `/portfolio/${this.language === 'English' ? 2 : 1}`
        restApi
        .get(search)
        .then(response => {
            let pdf = response.portfolio.image.imageName
            this.portfolioUrl = `https://dev.aggelopoulos-sarantis.com/uploads/images/${pdf}`
        })
        .catch((error) => {
            console.log(error)
        })
    }
  }
};
</script>

<style lang="scss" scoped>
  #app { 
    font-family: Arial, Helvetica, sans-serif;
    min-height: auto;
  }

</style>
